export const getScoreLabel = (score: number | string) => {
  const parsedNumber = Number(score);
  if (isNaN(parsedNumber)) return score;
  let result = '';
  if (parsedNumber <= 20) {
    result = '매우 낮음';
  } else if (parsedNumber <= 40) {
    result = '낮음';
  } else if (parsedNumber <= 60) {
    result = '보통';
  } else if (parsedNumber <= 80) {
    result = '우수';
  } else {
    result = '매우 우수';
  }
  return `${result} (${parsedNumber})`;
};

export const getScoreColor = (score: number | string | null) => {
  const parsedNumber = Number(score);
  if (
    typeof score === 'string' &&
    ['미제출', '미제출 (0)', '평가중', '대기중'].includes(score)
  )
    return 'GRAY_06';
  if (isNaN(parsedNumber) || score === null) return 'GRAY_08';
  if (parsedNumber <= 20) {
    return 'RED_01';
  } else if (parsedNumber <= 40) {
    return 'YELLOW';
  } else if (parsedNumber <= 60) {
    return 'BLUE';
  } else if (parsedNumber <= 80) {
    return 'GREEN_02';
  } else {
    return 'GREEN_01';
  }
};
